import { render, staticRenderFns } from "./NotificaTab.vue?vue&type=template&id=3abab098"
import script from "./NotificaTab.vue?vue&type=script&lang=js"
export * from "./NotificaTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports